<div class="app-container">
  @if (getUserLoginProgressPercentileEqual100 && !getIsCurrentSelectedNavigationPageLogin) {
    <div class="side-nav">
      <app-side-nav
        (contractMenu)="onToggleSideMenu('contract')"
        (sizeChange)="onMenuSizeChange($event)"
        [navigation]="getCurrentSelectedNavigationPage"
        [setNavigationPages]="getCopyOfSubPages"
        [setUserAccess]="(getUserAccess$ | ngrxPush)"
        [setUser]="getUser">
      </app-side-nav>
    </div>

    <div class="content">
      <app-page-header
        (expandSideMenu)="onToggleSideMenu('expand')"
        [isUserLogOutModalOpen]="(getIsLogOutModalOpen$ | ngrxPush)"
        [setIsUserAccessLoading]="(getIsUserNotificationsLoading$ | ngrxPush)"
        [setIsUserNotificationsLoading]="(getIsCurrentUserAccessLoading$ | ngrxPush)"
        [setNotificationTotals]="(getNotificationTotals$ | ngrxPush)"
        [title]="getCurrentPageText()"
        [setUserStores]="userStores$ | ngrxPush"
        [currentFeature]="(selectedFeature$ | ngrxPush)"
        [userAccess]="(getUserAccess$ | ngrxPush)"
        [user]="getUser">
      </app-page-header>

      <div class="content-body">
        @if (showFeatureStoreNoAccess) {
          <app-feature-store-no-access [storeName]="featureStoreNoAccessStoreName"></app-feature-store-no-access>
        } @else {
          <router-outlet></router-outlet>
        }

        @if ((showLoadingIndicator$ | ngrxPush)) {
          <div class="app-loading-indicator">
            <div>
              <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
              <span>
                  Loading
              <span class="bouncing-dots">
                <span class="dot dot-1">.</span>
                <span class="dot dot-2">.</span>
                <span class="dot dot-3">.</span>
              </span>
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="content-login ">
      <div class="content-body">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
</div>

@if ((showGlobalModal$ | ngrxPush)) {
  <app-global-modal-container></app-global-modal-container>
}
